import { render, staticRenderFns } from "./PurchaseDeliveryNewList.vue?vue&type=template&id=447a1820"
import script from "./PurchaseDeliveryNewList.vue?vue&type=script&lang=js"
export * from "./PurchaseDeliveryNewList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDeliveryNewList.vue?vue&type=style&index=0&id=447a1820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports